import React, { useEffect, useState } from 'react'
import { Wrapper } from './styles'
import { useDispatch, useSelector } from 'react-redux'
import { SearchInput } from '../HomeScreen/styles'
import moment from 'moment'
import Reservation from './Reservation'
import { getReservations } from 'src/state/consumer-reservations'
import { State } from 'src/state'
import { isPaying } from '@meniudigital/shared/users'
import { InfoPanel } from 'src/global'
import { usersSelector } from 'src/state/selectors'
import { useNavigate } from 'react-router-dom'
import { Screen } from '../../screens'

export default function ReservationsScreen() {
  const [query, setQuery] = useState('')
  const dispatch = useDispatch()
  const { user } = useSelector(usersSelector)
  const navigate = useNavigate()

  const reservations = useSelector((state: State) => state.reservations.list)

  useEffect(() => {
    dispatch(getReservations())
  }, [])

  if (!user) {
    return null
  }

  const filteredReservations = reservations
    .filter(x => (x.consumer.fullName || '').toLowerCase().includes(query.toLowerCase()))
    .sort((a, b) => (+moment(b.createdAt) > +moment(a.createdAt!) ? 1 : -1))
    .slice(0, 50)

  return (
    <>
      <Wrapper>
        <div className="top-bar">
          <SearchInput
            placeholder="Caută rezervare..."
            value={query}
            onChange={e => {
              setQuery(e.target.value)
            }}
          />
        </div>

        {!isPaying(user) && (
          <InfoPanel
            type="info"
            text="În varianta de test poți crea până la 3 rezervări pentru a testa funcționalitatea."
            nonDismissable
            actionButton={{
              label: 'Alege un abonament',
              onClick: () => navigate(user.subscriptionExpiresAt ? Screen.RenewSubscription : Screen.ChooseSubscription),
            }}
          />
        )}

        <div className="action-list">
          {filteredReservations.map(x => (
            <Reservation reservation={x} />
          ))}
        </div>
      </Wrapper>
    </>
  )
}
